/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Relax_Paywall_Soundscape_TitleInputs */

const en_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immersive in More Soundscapes`)
};

const ar_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اندماج أعمق في المزيد من المناظر الصوتية`)
};

const de_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eintauchen in mehr Klangwelten`)
};

const es_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumérgete en más paisajes sonoros`)
};

const fr_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plongez dans plus de paysages sonores`)
};

const it_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immergiti in più Soundscape`)
};

const ja_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さらに多くのサウンドスケープで、心を深く癒そう`)
};

const ko_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다양한 사운드스케이프와 함께 몰입하세요`)
};

const pt_br_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imerso em mais Paisagens Sonoras`)
};

const ru_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Погружайтесь в большее количество звуковых ландшафтов`)
};

const th_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดื่มด่ำไปกับทัศนีภาพแห่งเสียงเพิ่มเติม`)
};

const tr_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha Fazla Ses Manzarasına Dal`)
};

const zh_cn_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随心切换
更多声音场景`)
};

const zh_tw_relax_paywall_soundscape_title = /** @type {(inputs: Relax_Paywall_Soundscape_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隨心切換
更多聲音場景`)
};

/**
* | output |
* | --- |
* | "Immersive in More Soundscapes" |
*
* @param {Relax_Paywall_Soundscape_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const relax_paywall_soundscape_title = /** @type {((inputs?: Relax_Paywall_Soundscape_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relax_Paywall_Soundscape_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relax_paywall_soundscape_title(inputs)
	if (locale === "ar") return ar_relax_paywall_soundscape_title(inputs)
	if (locale === "de") return de_relax_paywall_soundscape_title(inputs)
	if (locale === "es") return es_relax_paywall_soundscape_title(inputs)
	if (locale === "fr") return fr_relax_paywall_soundscape_title(inputs)
	if (locale === "it") return it_relax_paywall_soundscape_title(inputs)
	if (locale === "ja") return ja_relax_paywall_soundscape_title(inputs)
	if (locale === "ko") return ko_relax_paywall_soundscape_title(inputs)
	if (locale === "pt_br") return pt_br_relax_paywall_soundscape_title(inputs)
	if (locale === "ru") return ru_relax_paywall_soundscape_title(inputs)
	if (locale === "th") return th_relax_paywall_soundscape_title(inputs)
	if (locale === "tr") return tr_relax_paywall_soundscape_title(inputs)
	if (locale === "zh_cn") return zh_cn_relax_paywall_soundscape_title(inputs)
	return zh_tw_relax_paywall_soundscape_title(inputs)
});